export const hasPrivilege = (privilegeName) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || !user.privileges) return false;

    // handle privileges as string or array
    let privileges = user.privileges;
    if (typeof privileges === "string") {
        privileges = privileges.split(",").map((p) => p.trim());
    }

    return privileges.includes(privilegeName);
};
